import { toast } from "react-toastify";
import { axiosInstance } from "../../Utils/AxiosInstance";
export const GetAllbanks = (data) => {
  return {
    type: "get_allbanks",
    payload: data,
    loading: false,
  };
};

export const StartGetBanks = () => {
  return {
    type: "get_allbanks",
    payload: [],
    loading: true,
  };
};
export function getallbanks(projectId) {
  return async (dispatch) => {
    dispatch(StartGetBanks());
    try {
      const pgurl = `Accounts/GetBankAccounts${projectId ? `?projectid=${projectId}` : ""}`;

      const result = await axiosInstance.get(pgurl);

      if (result.data.IsSuccess === true) {
        dispatch(GetAllbanks(result.data.Data));
      } else {
        toast.error(result.data.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}

export const GetAllCash = (data) => {
  return {
    type: "get_allcash",
    payload: data,
    loading: false,
  };
};

export const StartGetCash = () => {
  return {
    type: "get_allcash",
    payload: [],
    loading: true,
  };
};
export function getallcash(projectId) {
  return async (dispatch) => {
    dispatch(StartGetCash());
    try {
      // Use Accounts/GetCashAccounts for cash, fallback handled
      const pgurl = `Accounts/GetCashAccounts${projectId ? `?projectid=${projectId}` : ""}`;

      const result = await axiosInstance.get(pgurl);

      if (result.data.IsSuccess === true) {
        dispatch(GetAllCash(result.data.Data));
      } else {
        toast.error(result.data.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}
